import Vue from 'vue'
import Router from 'vue-router'

import consultaRoutes from '../features/consulta/routes'
import presentacionRoutes from '../features/presentacion/routes'
import dashboardRoutes from '../features/dashboard/routes'
import fichaRoutes from '../features/ficha/routes'
import presentacionDraftRoutes from '../features/presentacion_draft/routes'
import presentacionUpdateRoutes from '../features/presentacion_update/routes'
import boletinesRoutes from '../features/boletines/routes'
import liquidacionesRoutes from '../features/liquidaciones_tv/routes'
import liquidacionesJugadoresRoutes from '../features/liquidaciones_jugadores/routes'
import eventosRoutes from '../features/eventos/routes'
import expedientesRoutes from '../features/expedientes/routes'
import notificacionesRoutes from '../features/notification/routes'
import presupuestoRoutes from '../features/presupuesto_economnico_financiero/routes'
import playersRoutes from '../features/players/routes'
import acountRoutes from '../features/account/routes'
import reportsRoutes from '../features/reports/routes'
import condicionesSalarialesRoutes from '../features/condicion_salarial/routes'
import commonRoutes from '../common/routes'
import pagoAJugadoresRoutes from '../features/pago_a_jugadores/routes'
import deudasEntreClubesRoutes from '../features/deudas_entre_clubes/routes'
import informesAuditoriasRoutes from '../features/informes-auditorias/routes'
import reportesPartidoRoutes from '../features/reports_match/routes'
import fichasDePartidosRoutes from '../features/fichas-de-partidos/routes'
import transferenciasJugadoresRoutes from '../features/transferencia_jugadores/routes'
import PresentacionCargaLpfListView from '../features/presentaciones_carga_lpf/routes'
import wizardJugadoresDupĺicadosRoutes from '../features/wizard_jugadores_dup/routes'
import reportesInformeAuditoriaClub from '../features/reports_informe_club/routes'

Vue.use(Router)

let routes = []
routes = routes.concat(
  consultaRoutes,
  presentacionRoutes,
  dashboardRoutes,
  fichaRoutes,
  presentacionDraftRoutes,
  presentacionUpdateRoutes,
  boletinesRoutes,
  liquidacionesRoutes,
  liquidacionesJugadoresRoutes,
  eventosRoutes,
  expedientesRoutes,
  notificacionesRoutes,
  presupuestoRoutes,
  playersRoutes,
  acountRoutes,
  reportsRoutes,
  condicionesSalarialesRoutes,
  commonRoutes,
  pagoAJugadoresRoutes,
  deudasEntreClubesRoutes,
  informesAuditoriasRoutes,
  reportesPartidoRoutes,
  fichasDePartidosRoutes,
  transferenciasJugadoresRoutes,
  PresentacionCargaLpfListView,
  wizardJugadoresDupĺicadosRoutes,
  reportesInformeAuditoriaClub
)

let router = new Router({
  routes: routes,
  mode: 'history'
})

export default router
